import { merge } from "lodash";
import React from "react";
import {
  experimentStrategy,
  extractPluginsConfig,
  fetchEmbedData,
  runStrategies,
  themeStrategy
} from "./../wix-ricos-common";
import { RICOS_VERSION } from "./../ricos-schema/next-schema";
import { runViewerStrategies } from "./runViewerStrategies";
const createWixRicosViewer = (RicosViewer) => function WixRicosViewer(props) {
  const {
    children,
    biSettings,
    instance,
    plugins,
    theme,
    wixExperiments,
    allowLinkPreviewPopover,
    httpClient,
    msid,
    baseUrl,
    previewMode,
    content,
    ...rest
  } = props;
  const experiments = experimentStrategy(wixExperiments);
  const strategyProps = runStrategies({
    plugins,
    instance,
    biSettings,
    experiments,
    wixRicosVersion: RICOS_VERSION,
    ricosVersion: RICOS_VERSION,
    httpClient,
    msid,
    viewer: true,
    content
  });
  const _rcProps = merge(
    strategyProps,
    runViewerStrategies(plugins, baseUrl, previewMode),
    extractPluginsConfig(plugins, strategyProps.helpers)
  );
  return /* @__PURE__ */ React.createElement(
    RicosViewer,
    {
      _rcProps,
      content,
      experiments: strategyProps.experiments,
      plugins,
      theme: themeStrategy(theme),
      ...allowLinkPreviewPopover && {
        linkPreviewPopoverFetchData: fetchEmbedData(instance)
      },
      ...rest
    },
    children
  );
};
export {
  createWixRicosViewer
};
//# sourceMappingURL=WixRicosViewerNext.js.map
